import React, { createContext, useContext, useEffect, useState } from "react";
import { dictionaries, SUPPORTED_LANGUAGES } from "@/i18n/dictionaries";

const LanguageContext = createContext(null);

const STORAGE_KEY = "mios.language";

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || "tr";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
  }, [language]);

  const t = dictionaries[language] || dictionaries.tr;

  function setLanguage(code) {
    if (SUPPORTED_LANGUAGES.some((l) => l.code === code)) {
      setLanguageState(code);
    }
  }

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, t, supported: SUPPORTED_LANGUAGES }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
